(() => {
  const money = (cents) => "$" + (cents / 100).toFixed(2);
  const boot = document.querySelector("[data-cart-boot]");
  let cart = boot ? JSON.parse(boot.textContent) : { item_count: 0, total_price: 0, items: [] };
  const drawer = document.querySelector("[data-cart-drawer]");
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
  const body = document.querySelector("[data-cart-body]");
  const foot = document.querySelector("[data-cart-foot]");
  const subEl = document.querySelector("[data-cart-subtotal]");
  const fill = document.querySelector("[data-ship-fill]");
  const msg = document.querySelector("[data-ship-msg]");
  const goal = (window.RA && window.RA.shipGoal) || 4000;
  const hdr = document.querySelector("[data-hdr]");

  const onScroll = () => document.body.classList.toggle("is-scrolled", window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  function itemImage(it) {
    if (!it.image) return "";
    if (typeof it.image === "string") return it.image;
    return it.image.src || it.image.url || "";
  }
  function itemTitle(it) {
    return it.title || it.product_title || "Product";
  }
  function paintShip(replay) {
    const pct = Math.min(100, Math.round((cart.total_price / goal) * 100));
    if (!fill) return;
    if (replay) {
      fill.style.transition = "none";
      fill.style.width = "0%";
      void fill.offsetWidth;
      fill.style.transition = "";
    }
    fill.style.width = pct + "%";
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    void drawer.offsetWidth;
    document.body.style.overflow = "hidden";
    drawer.classList.add("is-open");
    paintShip(true);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(() => { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, 380);
  }

  function render() {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle("is-zero", !cart.item_count);
    });
    document.querySelectorAll("[data-cart-toggle]").forEach((b) => {
      b.setAttribute("aria-label", "Cart (" + cart.item_count + ")");
    });
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = "<p>Your cart is empty</p>";
      if (foot) foot.hidden = true;
    } else {
      body.innerHTML = cart.items.map((it) => {
        const img = itemImage(it);
        const key = it.key;
        return '<div class="cart-line">' +
          (img ? '<img src="' + img + '" alt="">' : "<span></span>") +
          "<div><a href=\"" + it.url + "\">" + itemTitle(it) + "</a>" +
            '<div class="cart-qty">' +
              '<button type="button" data-cart-qty="-1" data-key="' + key + '">-</button>' +
              "<span>" + it.quantity + "</span>" +
              '<button type="button" data-cart-qty="1" data-key="' + key + '">+</button>' +
            "</div></div>" +
          '<div class="cart-line-price">' + money(it.final_line_price) +
            '<button class="cart-remove" type="button" data-cart-qty="0" data-key="' + key + '">Remove</button>' +
          "</div></div>";
      }).join("");
      if (foot) foot.hidden = false;
    }
    if (subEl) subEl.textContent = money(cart.total_price);
    paintShip(false);
    if (msg) {
      msg.textContent = cart.total_price >= goal
        ? "You have unlocked free shipping."
        : "You are " + money(goal - cart.total_price) + " away from free shipping.";
    }
  }

  async function refresh() {
    const r = await fetch("/cart.js");
    cart = await r.json();
    render();
  }
  async function add(id, qty) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: qty || 1 })
    });
    await refresh();
    openDrawer();
  }
  async function change(key, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await refresh();
  }

  let qtyBusy = false;

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-nav-toggle]")) hdr && hdr.classList.toggle("is-open");
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      openDrawer();
    }
    if (e.target.closest("[data-cart-close]") || e.target === drawer) {
      closeDrawer();
    }
    const cq = e.target.closest("[data-cart-qty]");
    if (cq) {
      e.preventDefault();
      if (qtyBusy) return;
      const key = cq.getAttribute("data-key");
      const line = cart.items.find((it) => it.key === key);
      const delta = Number(cq.getAttribute("data-cart-qty"));
      const next = delta === 0 ? 0 : Math.max(0, (line ? line.quantity : 0) + delta);
      qtyBusy = true;
      change(key, next).finally(() => { qtyBusy = false; });
    }
    const atc = e.target.closest("[data-add]");
    if (atc) { e.preventDefault(); add(atc.getAttribute("data-add"), 1); }
    const q = e.target.closest("[data-qty]");
    if (q) {
      const input = q.parentElement.querySelector("input[name=quantity]");
      const n = Math.max(1, Number(input.value || 1) + Number(q.getAttribute("data-qty")));
      input.value = n;
    }
    const thumb = e.target.closest("[data-thumb]");
    if (thumb) {
      const main = document.querySelector("[data-main-img]");
      if (main) main.src = thumb.getAttribute("data-thumb");
      thumb.parentElement.querySelectorAll("button").forEach((b) => b.classList.remove("is-on"));
      thumb.classList.add("is-on");
    }
  });

  const form = document.querySelector("[data-atc-form]");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      add(form.querySelector("input[name=id]").value, Number(form.querySelector("input[name=quantity]").value || 1));
    });
  }

  const upsell = document.querySelector("[data-upsell]");
  if (upsell) {
    upsell.querySelectorAll("[data-upsell-tab]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-upsell-tab");
        upsell.querySelectorAll("[data-upsell-tab]").forEach((b) => b.classList.toggle("is-on", b === btn));
        upsell.querySelectorAll("[data-upsell-panel]").forEach((p) => {
          p.hidden = p.getAttribute("data-upsell-panel") !== id;
        });
      });
    });
  }

  document.querySelectorAll("[data-con]").forEach((box) => {
    const slides = [...box.querySelectorAll("[data-con-slide]")];
    box.querySelectorAll("[data-con-tab]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const i = Number(btn.getAttribute("data-con-tab"));
        box.querySelectorAll("[data-con-tab]").forEach((b) => b.classList.toggle("is-on", b === btn));
        slides.forEach((s, idx) => s.classList.toggle("is-on", idx === i));
      });
    });
  });

  const period = document.querySelector("[data-period]");
  if (period) {
    period.querySelectorAll("[data-period-tab]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-period-tab");
        period.querySelectorAll("[data-period-tab]").forEach((b) => b.classList.toggle("is-on", b === btn));
        period.classList.toggle("is-night", id === "pm");
        period.querySelectorAll("[data-period-panel]").forEach((p) => {
          p.hidden = p.getAttribute("data-period-panel") !== id;
        });
      });
    });
  }

  const more = document.querySelector("[data-reviews-more]");
  if (more) {
    more.addEventListener("click", () => {
      document.querySelectorAll("[data-more-review]").forEach((el) => { el.hidden = false; });
      more.remove();
    });
  }

  function markMid(track) {
    const reels = [...track.querySelectorAll(".reel")];
    if (!reels.length) return;
    const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
    let best = reels[0];
    let bestDist = Infinity;
    reels.forEach((el) => {
      const r = el.getBoundingClientRect();
      const d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bestDist) { bestDist = d; best = el; }
    });
    const i = reels.indexOf(best);
    reels.forEach((el, idx) => {
      el.classList.toggle("is-mid", el === best);
      el.classList.toggle("is-near", idx === i - 1 || idx === i + 1);
    });
  }

  document.querySelectorAll("[data-carousel]").forEach((root) => {
    const track = root.querySelector("[data-track]");
    if (!track) return;
    const reels = [...track.querySelectorAll(".reel")];
    const prev = root.querySelector("[data-prev]");
    const next = root.querySelector("[data-next]");

    if (reels.length) {
      let i = reels.findIndex((el) => el.classList.contains("is-mid"));
      if (i < 0) i = Math.min(2, reels.length - 1);
      let locked = false;
      const go = (n, smooth) => {
        i = ((n % reels.length) + reels.length) % reels.length;
        locked = true;
        reels.forEach((el, idx) => {
          el.classList.toggle("is-mid", idx === i);
          el.classList.toggle("is-near", idx === i - 1 || idx === i + 1);
        });
        const el = reels[i];
        const left = el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: smooth ? "smooth" : "auto" });
        window.setTimeout(() => { locked = false; markMid(track); }, 420);
      };
      if (prev) prev.addEventListener("click", (e) => { e.preventDefault(); go(i - 1, true); });
      if (next) next.addEventListener("click", (e) => { e.preventDefault(); go(i + 1, true); });
      track.addEventListener("scroll", () => {
        if (locked) return;
        markMid(track);
        const midX = track.getBoundingClientRect().left + track.clientWidth / 2;
        let best = i;
        let bestDist = Infinity;
        reels.forEach((el, idx) => {
          const r = el.getBoundingClientRect();
          const d = Math.abs(r.left + r.width / 2 - midX);
          if (d < bestDist) { bestDist = d; best = idx; }
        });
        i = best;
      }, { passive: true });
      window.addEventListener("resize", () => go(i, false));
      go(i, false);
      return;
    }

    const step = () => {
      const item = track.querySelector(".card, .ing") || track.children[0];
      if (!item) return 300;
      const gap = parseFloat(getComputedStyle(track).gap) || 12;
      return item.offsetWidth + gap;
    };
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  });

  const ts = document.querySelector("[data-ts]");
  if (ts) {
    const qs = [...ts.querySelectorAll("[data-ts-q]")];
    const bas = [...ts.querySelectorAll("[data-ts-ba]")];
    const dots = [...ts.querySelectorAll("[data-ts-dots] button")];
    let i = 0;
    const show = (n) => {
      i = ((n % qs.length) + qs.length) % qs.length;
      qs.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
      bas.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
      dots.forEach((el, idx) => el.classList.toggle("is-on", idx === i));
    };
    let timer = setInterval(() => show(i + 1), 7000);
    dots.forEach((d, idx) => d.addEventListener("click", () => { show(idx); clearInterval(timer); timer = setInterval(() => show(i + 1), 9000); }));
  }

  function bindBa(slide) {
    const before = slide.querySelector("[data-ba-before]");
    const div = slide.querySelector("[data-ba-div]");
    if (!before || !div) return;
    const set = (pct) => {
      const p = Math.max(6, Math.min(94, pct));
      before.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
      div.style.left = p + "%";
    };
    set(90);
    const move = (clientX) => {
      const r = slide.getBoundingClientRect();
      set(((clientX - r.left) / r.width) * 100);
    };
    let drag = false;
    slide.addEventListener("pointerdown", (e) => { drag = true; slide.setPointerCapture(e.pointerId); move(e.clientX); });
    slide.addEventListener("pointermove", (e) => { if (drag) move(e.clientX); });
    slide.addEventListener("pointerup", () => { drag = false; });
    slide.addEventListener("pointercancel", () => { drag = false; });
  }
  document.querySelectorAll("[data-ba]").forEach(bindBa);

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((ents) => {
      ents.forEach((en) => { if (en.isIntersecting) en.target.classList.add("is-in"); });
    }, { threshold: 0.28 });
    document.querySelectorAll("[data-hotspots]").forEach((hot) => io.observe(hot));
  }

  document.querySelectorAll("[data-reel]").forEach((v) => {
    const card = v.closest(".reel");
    const play = () => {
      document.querySelectorAll("[data-reel]").forEach((o) => {
        if (o !== v) { o.pause(); o.closest(".reel").classList.remove("is-play"); }
      });
      v.play();
      card.classList.add("is-play");
    };
    card.addEventListener("mouseenter", play);
    card.addEventListener("click", play);
    v.addEventListener("pause", () => card.classList.remove("is-play"));
  });

  render();
})();
